export class TransactionType {
  transactionTypeId: number;
  name: string;
}
